import ExampleHelpButton from '../example-buttons/ExampleHelpButton.vue';
import ExampleFrameButton from '../example-buttons/ExampleFrameButton.vue';

# License

This section tells you about your current CanvasPro license and how long the license lasts for.

You can also request to renew this license, this will open a support query to contact Digital Media Technologies (The creators of CanvasPro) which will be handled in accordance with your Service Level Agreement.

# Details

This section is to configure meta data for your CanvasPro installation.

## Player Name

The name of your CanvasPro installation. This may be viewable by other CanvasPro applications on the network.

## Player Description

If you need to add extra information about this player, this is the place to add it.

## Logs

Downloads the logs as a txt file, this is useful for troubleshooting or sending back to Digital Media Technologies for help.

## Save Button

Saves the changes you have made.

# Canvas Configuration

This section is where you configure your Canvas.

## Canvas

In CanvasPro the Canvas is the representation of your display, this could be one display or a cluster of displays. In a cluster your Canvas would be the total collective display area.

### Width and Height

CanvasPro aims to be as flexible as our customers, therefore you can completely customize the width and height of your total area. You are not constrained by aspect ratios.
